import { useEffect } from 'react'

import Api from 'services/api'

import { useStoreContext } from 'hooks/StoreContext'
import { useSessionContext } from 'hooks/SessionContext'

const useFavorites = (userId) => {
  const { favorites, setFavorites, areFavoritesLoaded, setAreFavoritesLoaded } = useStoreContext()
  const { session: { isTechnician, isAdmin, isFsr } } = useSessionContext()

  useEffect(() => {
    setFavorites(null)
    setAreFavoritesLoaded(false)

    if (!(isTechnician || isAdmin || isFsr)) {
      setAreFavoritesLoaded(true)
      return
    }

    Api.Favorite.list(userId)
      .then((res) => {
        setFavorites(res.deviceIds.sort())
        setAreFavoritesLoaded(true)
      })
      .catch(() => {
        setAreFavoritesLoaded(true)
      })
  }, [isTechnician, isAdmin, isFsr, userId, setFavorites, setAreFavoritesLoaded])

  return { favorites, areFavoritesLoaded }
}

export default useFavorites
